import React from "react";

export const LegalPage = ({ title, updated, testid, children }) => (
  <div data-testid={testid}>
    <div className="border-b border-white/10 grid-bg">
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-16">
        <p className="font-mono-tech text-xs uppercase text-[#00F0FF] mb-3">Legal</p>
        <h1 className="font-display font-extrabold text-4xl sm:text-5xl">{title}</h1>
        <p className="mt-3 text-sm text-[#94A3B8]">Last updated: {updated}</p>
      </div>
    </div>
    <div className="max-w-4xl mx-auto px-6 md:px-12 py-12 space-y-10">{children}</div>
  </div>
);

export const Section = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="font-display font-bold text-xl md:text-2xl text-white">{title}</h2>
    <div className="space-y-3 text-[#94A3B8] text-sm md:text-base leading-relaxed">{children}</div>
  </section>
);

export const P = ({ children }) => <p>{children}</p>;

export const Sub = ({ label, children }) => (
  <p><span className="text-white font-medium">{label}</span> {children}</p>
);

export const Bullets = ({ items }) => (
  <ul className="list-disc pl-6 space-y-1.5">
    {items.map((it, i) => <li key={i}>{it}</li>)}
  </ul>
);
